import React, { createContext, useContext, useReducer } from 'react';

export const professionalDashboardContext = createContext();

export const ProfessionalDashboardState = ({ reducer, initialState, children }) => (
  <professionalDashboardContext.Provider value={useReducer(reducer, initialState)}>{children}</professionalDashboardContext.Provider>
);

export const useStateProfessionalDashboardValue = () => useContext(professionalDashboardContext);